// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import DashboardPage from './pages/DashboardPage';
import CreateAccount from "./pages/CreateAccount";
import AccountsPage from './pages/AccountsPage';
import PaymentsPage from './pages/PaymentsPage';
import ReceivePage from './pages/ReceivePage';
import SendPage from './pages/SendPage';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider } from './context/AuthContext';
import ScrollToTop from './components/ScrollToTop';  // ADD THIS

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />  {/* ADD THIS - Will scroll to top on every route change */}
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<SignupPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/receive" element={<ReceivePage />} />
          <Route path="/send" element={<SendPage />} />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;